module.exports = __webpack_public_path__ + "img/ic_32_system_apple.6cb84490.svg";